export const THIRTY_DAYS = new Date().setTime(new Date().getTime() + 30 * 30 * 24 * 60 * 60 * 1000)